export const getCommonData = (agents: any[]) => {
  return (agents || []).map((agent) => ({
    ...agent,
    violations: agent.violations?.length || "",
    lastViolation: agent.violations?.[0]?.timestamp || ""
  }))
}

export const getAgentData = (data: any) => {
  return data?.[0]?.violations || []

  return [
    {
      date: "Oct 1, 2026, 09:33",
      rule: "Tool capability",
      values: ["format cpu"],
      actions: {
        enforceRuleOnRuntime: true,
        preventViolationOnDevelopment: false,
        notifyOnViolation: true
      }
    },
    {
      date: "Oct 1, 2026, 09:33",
      rule: "Tool capability",
      values: ["format cpu"],
      actions: {
        enforceRuleOnRuntime: true,
        preventViolationOnDevelopment: false,
        notifyOnViolation: true
      }
    },
    {
      date: "Oct 1, 2026, 09:33",
      rule: "Tool capability",
      values: ["format cpu"],
      actions: {
        enforceRuleOnRuntime: true,
        preventViolationOnDevelopment: false,
        notifyOnViolation: true
      }
    },
    {
      date: "Oct 1, 2026, 09:33",
      rule: "Model",
      values: ["Grok_Death_star.666"],
      actions: {
        enforceRuleOnRuntime: false,
        preventViolationOnDevelopment: true,
        notifyOnViolation: false
      }
    }
  ].map((_, index) => ({ ..._, key: `${index}` }))
}
